import Fragment from './Fragment.js'
import OrderByHeader from './OrderByHeader.js'

// this component is used for delineating levels in broekrAllocation until we figure out how to deal with that issue, remove in refactor of UI.
export default {
    orderByHeader: OrderByHeader,
    fragment: Fragment,
}
